export default __webpack_public_path__ + "static/media/039-fall.b03ef098.svg";